import { render, staticRenderFns } from "./PaymentTypes.vue?vue&type=template&id=38a25aa3&scoped=true&"
import script from "./PaymentTypes.vue?vue&type=script&lang=js&"
export * from "./PaymentTypes.vue?vue&type=script&lang=js&"
import style0 from "./PaymentTypes.vue?vue&type=style&index=0&id=38a25aa3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a25aa3",
  null
  
)

export default component.exports